import { render, staticRenderFns } from "./DefaultSignupComplete.vue?vue&type=template&id=b4d81baa&lang=pug&"
import script from "./DefaultSignupComplete.vue?vue&type=script&lang=ts&"
export * from "./DefaultSignupComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports